// import React, { useState } from "react";

// function ImageIconExample() {
//   const [icon, setIcon] = useState(null);

//   const handleUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const url = URL.createObjectURL(file);
//     setIcon(url);
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <input type="file" accept="image/*" onChange={handleUpload} />
//       <br />

//       {icon && (
//         <img
//           src={icon}
//           alt="icon"
//           style={{
//             width: 25,
//             height: 25,
//             borderRadius: 6,
//             objectFit: "cover",
//             marginTop: 10,
//           }}
//         />
//       )}
//     </div>
//   );
// }

// export default ImageIconExample;
// import React, { useState } from "react";

// export default function ImageIconExample() {
//   const [icon, setIcon] = useState(null);

//   const handleUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const url = URL.createObjectURL(file);
//     setIcon(url);
//   };

//   return (
//     <div style={{ padding: 20 }}>
//       <h3>Upload Image → Icon Style</h3>

//       <input type="file" accept="image/*" onChange={handleUpload} />

//       {icon && (
//         <div
//           style={{
//             marginTop: 15,
//             width: 32,
//             height: 32,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             background: "#f5f5f5",
//             borderRadius: 6,
//             border: "1px solid #ddd",
//           }}
//         >
//           <img
//             src={icon}
//             alt="icon"
//             style={{
//               width: 20,
//               height: 20,
//               objectFit: "contain",
//             }}
//           />
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useState } from "react";

export default function ImageIconExample() {
  const [icon, setIcon] = useState(null);

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const url = URL.createObjectURL(file);
    setIcon(url);
  };

  return (
    <div style={{ padding: 20 }}>
      <input type="file" accept="image/*" onChange={handleUpload} />

      {icon && (
        <div
          style={{
            marginTop: 15,
            width: 24,
            height: 24,
            backgroundImage: `url(${icon})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        />
      )}
    </div>
  );
}
